import React, { useEffect, useState } from 'react';
import FeedbackNonSelfLearningTabComponent from '../../Component/Tabs/FeedbackNonSelfLearningTabComponent';
import { toastr } from 'react-redux-toastr';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from '@tanstack/react-query';
import { contentManagementContentFeedbackAPI } from '../../../../../Services/ElearningContentManagement/contentFeedback';
import CButton from '../../../../../Assets/Components/CButton';
import { Switch } from 'antd';
import FeedbackNonSelfLearningModalContainer from '../Modal/FeedbackNonSelfLearningModalContainer';
import ErrorHandler from '../../../../../App/ErrorHandler';

interface IProps {
  currentTab: string;
  stage: any;
  submodule: any;
}

export default function FeedbackNonSelfLearningTabContainer(props: IProps) {
  const { currentTab, stage, submodule } = props;
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedData, setSelectedData] = useState();

  useEffect(() => {
    if (submodule) return;
    setSelectedStatus(undefined);
    setFilter(undefined);
  }, [submodule]);

  useEffect(() => {
    if (currentTab !== 'FeedbackOffline') return;
    setSelectedStatus(undefined);
    setFilter(undefined);
  }, [currentTab]);

  const {
    data: dataFeedback,
    isLoading: isLoadingFeedback,
    isRefetching: isRefetchFeedback,
    refetch,
  } = useQuery(
    [
      'getContentManagementFeedbackNonSelfAPI',
      { id: submodule?.id, type: 'NonSelfLearning' },
    ],
    contentManagementContentFeedbackAPI.getFeedback,
    {
      refetchOnWindowFocus: false,
      enabled: submodule?.id !== undefined,
    },
  );

  const mutateDelete = useMutation(
    contentManagementContentFeedbackAPI.deleteFeedback,
    {
      onError: (error: any) => {
        ErrorHandler(error);
      },
      onSuccess: () => {
        toast.success(
          <span className="capitalFirst">Feedback Berhasil Dihapus</span>,
        );
        refetch();
      },
    },
  );

  const mutateFeedbackStatus = useMutation(
    contentManagementContentFeedbackAPI.mutateFeedbackStatus,
    {
      onSuccess: () => {
        setShowModal(false);
        refetch();
        toast.success(
          <span className="capitalFirst">Feedback Berhasil Diupdate!</span>,
        );
      },
      onError: (error: any) => {
        ErrorHandler(error);
      },
    },
  );

  const processStatusChannel = (id: number, status?: boolean) => {
    mutateFeedbackStatus.mutate({ status, id });
  };
  const processEnabledStatus = (id: number, status: boolean, row: any) => {
    const rowData = row.row.original;
    const action = status === true ? 'mengaktifkan' : 'menon-aktifkan';
    const actionConfirm = status === true ? 'Aktifkan' : 'Non-Aktifkan';
    const toastrConfirmOptions = {
      okText: actionConfirm,
      cancelText: 'Batalkan',
      onOk: () => processStatusChannel(id, status),
      id: 'toastRConfirm',
    };
    toastr.confirm(
      `Anda yakin ingin ${action} Feedback "${rowData.category}"?`,
      toastrConfirmOptions,
    );
  };

  const renderStatus = row => {
    const rowData = row.row.original;
    const processEnabled = isChecked =>
      processEnabledStatus(rowData.id, isChecked, row);
    return (
      <Switch
        onChange={processEnabled}
        checked={rowData.isActive}
        id={rowData.id}
      />
    );
  };

  const renderAction = row => {
    const rowData = row.row.original;
    const handleEdit = () => {
      setSelectedData(rowData);
      setShowModal(true);
    };
    const handleDelete = () => {
      const toastrConfirmOptions = {
        okText: 'Delete',
        cancelText: 'Batalkan',
        onOk: () => mutateDelete.mutate(rowData.id),
        id: 'toastConfirmQuestionContent',
      };
      toastr.confirm(
        `Delete Feedback content "${rowData.category}"`,
        toastrConfirmOptions,
      );
    };
    const dataButton = [
      {
        id: `btnDeleteContentQuestion`,
        type: 'danger',
        icon: 'DeleteOutlined',
        className: 'buttonTable',
        onClick: handleDelete,
      },
      {
        id: `btnEditContentQuestion`,
        type: 'primary',
        icon: 'EditOutlined',
        onClick: handleEdit,
        className: 'buttonTable',
      },
    ];
    return <CButton buttonData={dataButton} />;
  };

  const renderTotalQuestion = row => {
    const detail = row.row.original;
    return (
      <p>
        {detail.essayQuestions.length + detail.multipleChoiceQuestions.length}
      </p>
    );
  };

  const columnData = [
    {
      Header: 'Feedback Category',
      accessor: 'category',
    },
    {
      Header: 'Sequence',
      accessor: 'sequence',
    },
    {
      Header: 'Total Question',
      Cell: row => renderTotalQuestion(row),
    },
    {
      Header: 'Status',
      Cell: row => renderStatus(row),
    },
    {
      Header: 'Action',
      Cell: row => renderAction(row),
    },
  ];

  const handleApplyfilter = () => setFilter(selectedStatus);
  const handleAdd = () => setShowModal(true);
  const handleRefresh = () => {
    refetch();
    setSelectedStatus(undefined);
    setFilter(undefined);
  };

  const data = dataFeedback
    ? filter === 'active'
      ? dataFeedback.filter(item => item.isActive)
      : filter === 'inactive'
        ? dataFeedback.filter(item => !item.isActive)
        : dataFeedback
    : [];

  return (
    <>
      <FeedbackNonSelfLearningTabComponent
        columnData={columnData}
        disabled={submodule && submodule.type !== null ? true : false}
        selectedStatus={selectedStatus}
        data={data}
        handleRefresh={handleRefresh}
        handleAdd={handleAdd}
        isLoading={
          isLoadingFeedback ||
          isRefetchFeedback ||
          mutateDelete.isLoading ||
          mutateFeedbackStatus.isLoading
        }
        setSelectedStatus={setSelectedStatus}
        handleApplyfilter={handleApplyfilter}
      />
      {showModal && (
        <FeedbackNonSelfLearningModalContainer
          data={data}
          stage={stage}
          submodule={submodule}
          showModal={showModal}
          setShowModal={setShowModal}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          handleRefresh={handleRefresh}
        />
      )}
    </>
  );
}
